module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"noResults":"Nenhum resultado encontrado."},"en-US":{"noResults":"No result found."}}')
  delete Component.options._Ctor
}
